// React Router navigation is internal. External links use native anchors.
const safeInternalPath = (value) => {
    if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return null;
    const pathname = value.split(/[?#]/, 1)[0];
    if (pathname.includes('\\') || Array.from(pathname).some((char) => char.charCodeAt(0) <= 32)) return null;
    try {
        const decoded = decodeURIComponent(pathname);
        if (decoded.startsWith('//') || decoded.startsWith('/\\') || Array.from(decoded).some((char) => char.charCodeAt(0) < 32)) return null;
    } catch (_) { return null; }
    return value;
};
module.exports = { safeInternalPath };
